// import { Box, useTheme } from '@mui/material';
// import React from 'react'
// import { Bar, Pie, Line } from 'react-chartjs-2'

// function EnergyReportingChart({ data, labels }) {
//     const { typography } = useTheme()


//     console.log("chartbala data",data)
//     console.log("chartbala labels",labels)
//     return (
//         <>
       

//         <Line style={{ overflow: 'scroll' }}
//             options={{
//                 responsive: true,
//                 maintainAspectRatio: true,
//                 animation: false,
//                 plugins: {
//                     legend: {
//                         position: 'top',
//                         display: true
//                     },
//                     title: {
//                         display: false,
//                         position: 'left',
//                         text: 'Temperature in Celsius Degree',
//                     },
//                     tooltip: {
//                         mode: 'index',
//                         intersect: false,
//                     },
//                     filler: {
//                         propagate: true
//                     }

//                 },
//                 spacing: 1,
//                 aspectRatio: 3,
//                 scales: {
//                     y: {
//                         ticks: {
//                             // color: 'yellow',
//                             font: {
//                                 size: 10,
//                             }
//                         }
//                     },
//                     x: {
//                         ticks: {
//                             // color: 'inherit',
//                             font: {
//                                 size: 10
//                             }
//                         }
//                     }
//                 }
//             }}
//             data={{
//                 labels: labels,
//                 datasets: data

//             }} />
//         </>
       


//     )
// }

// export default EnergyReportingChart


import React, { useRef, useEffect } from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";

const EnergyReportingChart = ({ data, labels }) => {
    const chartRef = useRef(null);

    const chartData = {
        labels,
        datasets: data,
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
            },
        },
    };

    // Save Chart with White Background
    const saveChart = () => {
        const chartInstance = chartRef.current;

        if (chartInstance) {
            const canvas = chartInstance.canvas;
            const ctx = canvas.getContext('2d');

            // Create offscreen canvas
            const offscreenCanvas = document.createElement('canvas');
            offscreenCanvas.width = canvas.width;
            offscreenCanvas.height = canvas.height;
            const offCtx = offscreenCanvas.getContext('2d');

            // Fill with white background
            offCtx.fillStyle = 'white';
            offCtx.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

            // Draw chart onto the offscreen canvas
            offCtx.drawImage(canvas, 0, 0);

            // Download chart as image
            const link = document.createElement('a');
            link.href = offscreenCanvas.toDataURL('image/png');
            link.download = 'energy-chart.png';
            link.click();
        }
    };

    useEffect(() => {
        saveChart();
    }, [data, labels]);

    return (
        <div>
            <Line
                ref={(chart) => (chartRef.current = chart ? chart.chartInstance : null)}
                data={chartData}
                options={options}
            />
        </div>
    );
};

export default EnergyReportingChart;


